class CustomCheckout {
  constructor() {
    this.isProd = true
    this.optBtnQuery = ''
    this.config = {
      "maketPrefix": ['/en-'],
      "host": this.isProd ? 'https://www.aosom.com' : 'https://popdev.aosom.com',
      "cartFormIdAttr": this.isProd ? 'form' : 'id',
      "headFormId": this.isProd ? 'CartDrawer-Form' : 'cart-notification-form',
      "headCartId": this.isProd ? 'shopify-section-cart-drawer' : 'cart-notification-form',
      "otherBtnId": this.isProd ? 'other-checkouts' : 'more-payment-options-link',
    }
    this.customerInfo = this.getCustomerInfo()
    this.init();
  }

  init() {
    if (window.location.pathname.includes('/cart')) {
      this.handleCartPageCheckout()
    } else {
      this.handleHeaderCheckout()
    }
  }
  isMarket() {
    let isMarket = false
    const path = window.location.pathname;
    if (this.config.maketPrefix.some(prefix => path.startsWith(prefix))) {
      isMarket = true
    }
    return isMarket
  }
  getSomeMaps() {
    const path = window.location.pathname;
    const match = path.match(/^\/([^\/]+)/);
    const firstDirectory = match ? match[1] : '';
    const maps = {
      'en-ca': {
        skuPrefix: 'CA-',
        market: 'en-ca'
      },
      'en-gb': {
        skuPrefix: 'UK-',
        market: 'en-gb'
      }
    }
    return {
      maps: maps,
      map: maps[firstDirectory] || null
    }
  }
  // 头部购物车弹窗 checkout 按钮处理
  handleHeaderCheckout() {
    let checkoutBtn = document.querySelector(`#${this.config.headCartId} [name="checkout"]`)
    this.optBtnQuery = `#${this.config.headCartId} [name="checkout"]`
    if (!checkoutBtn) return;
    checkoutBtn.removeAttribute("disabled")
    // const formEl = document.getElementById(this.config.headFormId)
    // if (!formEl) return;
    // 新增委托绑定
    document.body.addEventListener('submit', (e) => {
      const target = e.target;
      if (target && target.id === this.config.headFormId && !this.ignorePreventDefault) {
        e.preventDefault()
        this.handleCheckout(1, target);
      }
    });
    // formEl.addEventListener("submit", e => {
    //   // 如果是市场，则拦截
    //   if (this.isMarket()) {
    //     e.preventDefault()
    //     console.log('------------------ checkout click event')
    //     this.handleCheckout(1)
    //   }
    // })
  }
  // 购物车页面 checkout 按钮处理
  handleCartPageCheckout() {
    let checkoutBtn = document.getElementById('checkout')
    this.optBtnQuery = '#checkout'
    if (this.isProd) {
      checkoutBtn = document.querySelector('[name="checkout"]')
      this.optBtnQuery = '[name="checkout"]'
    }
    if (!checkoutBtn) return;
    if (checkoutBtn.getAttribute("data-empty") !== '1') {
      checkoutBtn.removeAttribute("disabled")
    }
    const isMarcket = this.isMarket()
    const formId = checkoutBtn.getAttribute('form')
    const formEl = document.getElementById(formId)
    if (!formEl) return;
    formEl.addEventListener("submit", e => {
      // 如果是市场，则拦截
      if (!this.ignorePreventDefault) {
        e.preventDefault();
        this.handleCheckout(2, checkoutBtn)
      }
    })
    // 其他按钮处理
    const otherCheckouts = document.getElementById(this.config.otherBtnId)
    if (otherCheckouts) {
      otherCheckouts.addEventListener("click", (e) => {
        // 如果是市场，则拦截
        if (!this.ignorePreventDefault) {
          e.preventDefault()
          console.log('------------------ checkout click event 1')
          this.handleCheckout(2, otherCheckouts)
        }
      })
    }
    if (!isMarcket) {
      otherCheckouts.style.display = "none"
    }
  }
  // 将Buffer转换为Base64
  arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }
  // 加签，返回拼接后的字符串
  paramSign(params, timestamp) {
    // 1. 去除空值并字典顺序排序
    const filteredParams = Object.keys(params)
      .filter(key => ['boolean', 'number', 'string'].includes(typeof params[key]))
      .sort((a, b) => a.localeCompare(b))
      .reduce((obj, key) => {
        obj[key] = params[key];
        return obj;
      }, {});

    // 2. 拼接时间戳和加密后的随机密钥
    const paramString = Object.entries(filteredParams).map(([key, value]) => `${key}^${value}`).join('*');
    return `${paramString}*timestamp^${timestamp}`;
  }
  // 加签，通过SHA算法获得签名
  async paramSign2(paramStr, isBase64) {
    // 3. 通过SHA算法获得签名
    const encoder = new TextEncoder();
    const data = encoder.encode(paramStr);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
    if (isBase64) {
      return this.arrayBufferToBase64(hashBuffer);
    } else {
      return hashBuffer;
    }
  }

  async getProdData() {
    // 获取购物车数据
    const drawerEl = document.getElementById("CartDrawer");
    const cartEls = drawerEl.querySelectorAll('li.cart-item') || []
    let cartDatas = []
    cartEls.forEach(item => {
      cartDatas.push({
        "mainSku": item.getAttribute('sku'),
        "qty": item.querySelector('.js-counter-quantity').value
      })
    })
    return cartDatas
  }
  async getCartSync() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart; // 返回数据后继续执行后续代码
    } catch (error) {
      console.error('获取失败:', error);
      return null;
    }
  }
  async getTestData() {
    let cartDatas = []
    const cartData = await this.getCartSync()
    const isMarcket = this.isMarket();
    const someMaps = this.getSomeMaps()
    let checkoutMarket = ''
    const currentMap = someMaps.map
    const allKeys = Object.keys(someMaps.maps)
    // 如何 currentMap 存在 对allKeys进行重新排序，优先把currentMap.market 放在第一位
    if (currentMap) {
      const idx = allKeys.indexOf(currentMap.market)
      if (idx > -1) {
        allKeys.splice(idx, 1)
        allKeys.unshift(currentMap.market)
      }
    }
    
    // 辅助函数：根据商品的 SKU 前缀判断它是否属于某个市场
    const getMarketForItem = (itemSku) => {
      if (isMarcket && someMaps.map && itemSku.startsWith(someMaps.map.skuPrefix)) {
        return someMaps.map.market;
      }
      if (!isMarcket) {
        const allKeys = Object.keys(someMaps.maps);
        for (const key of allKeys) {
          if (itemSku.startsWith(someMaps.maps[key].skuPrefix)) {
            return someMaps.maps[key].market;
          }
        }
      }
      return null;
    };

    // 1. 筛选出当前市场的主商品，并确定 checkoutMarket
    const marketItems = [];
    for (const item of cartData.items) {
      const market = getMarketForItem(item.sku);
      if (market) {
        marketItems.push(item);
        // 确定结算市场（如果是非市场页面，只取第一个匹配市场的商品）
        if (!checkoutMarket) {
          checkoutMarket = market;
        }
      }
    }

    // 2. 将市场主商品添加到 cartDatas
    marketItems.forEach(item => {
      // 排除保险产品，只添加主商品
      if (item.handle !== "product-protection") {
        cartDatas.push({
          "mainSku": item.sku,
          "qty": item.quantity
        });
      }
    });

    // 3. 处理保险产品 (handle: "product-protection")
    cartData.items.forEach(item => {
      if (item.handle === "product-protection" && checkoutMarket) {
        const referenceId = item.properties?.Reference; // 获取 Reference 属性
        
        // 检查该保险产品是否属于当前结算市场的某个主商品
        // 这里的逻辑是：检查 Reference 是否与当前市场中任何一个主商品ID匹配。
        // 注意：保险产品的 Reference 应该引用的是主商品的 item.id 或 item.variant_id。
        // Shopify cart.js 返回的 item.id 是 line item ID，item.variant_id 是变体 ID。
        // 假设 Reference 存储的是 item.id
        const isAttachedToMarketItem = marketItems.some(marketItem => {
          // 确保 Reference 值存在且与主商品的 ID 匹配
          // 注意：这里需要明确知道保险Reference对应的是主商品的哪个ID（是 variant_id 还是 line item ID）
          // 假设 Reference 存储的是 line item ID (item.id)
          return referenceId && (referenceId == marketItem.id || referenceId == marketItem.variant_id); 
        });

        if (isAttachedToMarketItem) {
          // 处理数据结构，使用 {key: '',value: ''} 的形式
          const propArr = [];
          if (item.properties) {
            for (let key in item.properties) {
              propArr.push({
                key: key,
                value: item.properties[key]
              })
            }
          }
          // 满足条件：是保险产品，且属于当前结算市场的某个主商品
          
          // 构建要push的对象，包含所有 properties 作为 attributes
          const insuranceData = {
            "mainSku": item.sku,
            "qty": item.quantity,
            "attributes": propArr // 将整个 properties 对象作为 attributes 字段
          };
          
          cartDatas.push(insuranceData);
        }
      }
    });

    console.log('-------------------- ', cartData); // 输出购物车数据
    return {
      cartDatas,
      checkoutMarket
    }
  }
  // 获取cookie
  getCookie(name) {
    try {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        const cookieValue = parts.pop().split(';').shift();
        return cookieValue ? decodeURIComponent(cookieValue) : null;
      }
      return null;
    } catch (error) {
      console.error('Error getting cookie:', error);
      return null;
    }
  }
  // 主店铺的登出逻辑
  subStoreLogout() {
    // 向所有子店铺发送登出指令
    const childDomains = ['https://outsunnystore.myshopify.com'];
    childDomains.forEach(domain => {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = `${domain}/account/logout`;
      document.body.appendChild(iframe);
    });
  }
  // 清空购物车
  clearCart() {
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        console.log('购物车已清空:', data);
        window.location.reload()
      })
      .catch(error => {
        console.error('清空购物车出错:', error);
      });
  }
  // 获取支付状态接口
  async getPayStatus(cartToken) {
    // 从cookie 获取购物车 token
    if (!cartToken) {
      return
    }
    fetch(`${this.config.host}/rest/v1/spf/lp/${cartToken}`)
      .then((response) => {
        return response.json();
      }).then(res => {
        if (res?.code === 0) {
          if (res?.data === 1) {
            // 支付成功，清空购物车
            this.clearCart()
          } else if (res?.data === 0) {
            // 继续轮询
            setTimeout(() => {
              this.getPayStatus(cartToken)
            }, 2000)
          } else if (res?.data === -1) {
            // 支付失败
            console.log('------------------ 支付失败')
          }
        }
      })
  }
  // 获取用户邮箱
  getCustomerInfo() {
    const uInfo = {}
    try {
      // 方法3：从页面元素获取
      const emailElement = document.querySelector('div[data-email]');
      if (emailElement) {
        uInfo.email = emailElement.getAttribute('data-email')
        uInfo.firstName = emailElement.getAttribute('first-name')
        uInfo.lastName = emailElement.getAttribute('last-name')
        emailElement.remove()
      }

      return uInfo;
    } catch (error) {
      console.error('Error getting customer email:', error);
      return uInfo;
    }
  }
  // 处理购物车弹窗 checkout 按钮点击操作
  async handleCheckout(type, target) {
    if (this.paying) {
      return
    }
    let { cartDatas, checkoutMarket } = await this.getTestData(type)
    if (checkoutMarket) {
      this.ignorePreventDefault = false
      const timestamp = new Date().getTime();
      // 可能需要加一个配置字典，来准确区分市场
      // const path = window.location.pathname;
      // const match = path.match(/^\/([^\/]+)/);
      // const firstDirectory = match ? match[1] : '';



      // !!! --------- 上线需要修改为动态获取的 market, store 字段
      const params = {
        items: cartDatas,
        "market": checkoutMarket,
        "host": window.location.host,
        ...this.customerInfo
      }
      const cartToken = this.getCookie('cart')
      const cartSign = this.getCookie('cart_sig')
      if (cartToken) {
        params.cartToken = cartToken
      }
      if (cartSign) {
        params.cartSig = cartSign
      }
      console.log('------------------ params', params)
      const signStr = this.paramSign(params, timestamp);
      const signature = await this.paramSign2(signStr, true);
      const headers = {
        "X-Timestamp": timestamp,
        "X-Signature": signature,
      }
      const otherConfigs = { ...fetchConfig() }
      if (otherConfigs.headers) {
        otherConfigs.headers = {
          ...otherConfigs.headers,
          ...headers
        }
      } else {
        otherConfigs.headers = headers
      }
      const body = JSON.stringify(params);
      this.paying = true
      const optBtnQueryEl = this.optBtnQuery && document.querySelector(this.optBtnQuery)
      if (optBtnQueryEl) {
        optBtnQueryEl.setAttribute('disabled', true)
      }
      // 按钮置灰
      fetch(`${this.config.host}/rest/v1/spf/checkout`, { ...otherConfigs, ...{ body } })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          console.log('------------- res', res)
          if (res && res.code === 0 && res.data) {
            optBtnQueryEl && optBtnQueryEl.removeAttribute('disabled')
            // https://outsunnystore.myshopify.com/cart/c/Z2NwLXVzLWVhc3QxOjAxSlBQVjFQTjhWRjg5WTBHNURRODNGM0FU?key=6a33f9a4fb7fdadfd60d5cc5bb903b5e，截取最后一级url
            // const urlObj = new URL(res.data)
            // const cartToken = urlObj.pathname.split('/').pop()
            // // 创建一个a标签，并在新标签页打开 res.data
            // const aEl = document.createElement("a");
            // aEl.href = res.data;
            // aEl.target = "_blank";
            // aEl.click();
            const irclickid = this.getCookie('irclickid')
            window.location.href = irclickid ? this.updateUrlParameter(res.data, 'im_ref', irclickid) : res.data
            // window.location.href = res.data
          } else {
            res.msg && window.alert(res.msg)
            this.paying = false
            optBtnQueryEl && optBtnQueryEl.removeAttribute('disabled')
          }
        }).catch(() => {
          this.paying = false
          optBtnQueryEl && optBtnQueryEl.removeAttribute('disabled')
        })
    } else {
      this.ignorePreventDefault = true
      target.click()
    }
  }

  // 更新URL
  updateUrlParameter(url, param, value) {
    const urlParts = new URL(url);
    urlParts.searchParams.set(param, value);
    return urlParts.toString();
  }
}
new CustomCheckout()

function CustomLocalization () {
  const countryLinks = document.querySelectorAll(".country-selector__trigger");
  countryLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault()
      if (link.dataset.value === 'FR') {
          window.location.href = 'https://outsunny.fr'
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  CustomLocalization()
})


class DrawerNavSection extends HTMLElement {
  constructor() {
    super();

    this.headerParentLinkClass = "wt-header__nav-teaser__link--parent";
    this.pageOverlayClass = "menu-drawer-overlay";
    this.triggerQuery = [
      ".wt-header__menu-trigger",
      `.${this.headerParentLinkClass}`,
      ".wt-drawer__close",
      `.${this.pageOverlayClass}`,
    ].join(", ");
    this.triggers = () => document.querySelectorAll(this.triggerQuery);
    this.getHeaderHeight = () =>
      getStyleProperty(document.querySelector(".wt-header"), "height");
    this.headerMenu = document.querySelector(".wt-header--v3");
    this.menuToggleButton = document.querySelector(".wt-header__menu-trigger");
    this.closeButton = this.querySelector(".wt-drawer__close");
    this.isOpen = false;
    this.triggerElement = null;
    this.isAlwaysMobile = () => document.body.classList.contains("mobile-nav");
    this.desktopBreakpoint = 1200;
    this.isDesktop = () =>
      window.matchMedia(`(min-width: ${this.desktopBreakpoint}px)`).matches;
  }

  connectedCallback() {
    this.init();
  }

  openMobileSubmenu(linkValue) {
    const menuParentLinks = document.querySelectorAll(
      ".wt-page-nav-mega__link--parent",
    );
    const classParentActiveMobile = "submenu-opened";

    menuParentLinks.forEach((link) => {
      link.classList.remove(classParentActiveMobile);

      if (link.attributes?.href?.value === linkValue) {
        link.classList.add(classParentActiveMobile);
        const subMenuLinks = link.nextElementSibling.querySelectorAll(
          'a[data-menu-level="2"]',
        );
        setTabindex(subMenuLinks, "0");
      }
    });
  }

  handleTabindex() {
    const linksLvl1 = this.querySelectorAll('a[data-menu-level="1"]');

    if (!this.isAlwaysMobile()) {
      setTabindex(linksLvl1, this.isDesktop() ? "0" : "-1");
    }
  }

  updateAriaStateForTriggers() {
    const triggers = document.querySelectorAll(
      "[aria-controls='wt-drawer-nav']",
    );
    triggers.forEach((trigger) => {
      const isOpen = this.isOpen;
      trigger.setAttribute("aria-expanded", isOpen);
    });
  }

  temporaryHideFocusVisible() {
    document.body.classList.add("no-focus-visible");
  }

  openMenu(e) {
    this.isOpen = true;
    this.triggerElement = e.currentTarget;
    this.closeButton.setAttribute("tabindex", "0");
    this.closeButton.focus();
    this.temporaryHideFocusVisible();
  }

  closeSubmenus() {
    const openSubmenus = this.querySelectorAll(".submenu-opened");
    openSubmenus.forEach((submenu) => {
      submenu.classList.remove("submenu-opened");

      // Deactivate level 2 links
      const subMenuLinksLevel2 = submenu.nextElementSibling.querySelectorAll(
        'a[data-menu-level="2"]',
      );
      setTabindex(subMenuLinksLevel2, "-1");

      // Deactivate level 3 links
      const subMenuLinksLevel3 = submenu.nextElementSibling.querySelectorAll(
        'a[data-menu-level="3"]',
      );
      setTabindex(subMenuLinksLevel3, "-1");
    });
  }

  closeMenu() {
    this.isOpen = false;
    this.triggerElement.focus();
    this.triggerElement = null;
    this.closeButton.setAttribute("tabindex", "-1");
    this.closeSubmenus();
    this.temporaryHideFocusVisible();
  }

  toggleMenu(e) {
    e.preventDefault();

    if (this.isOpen) {
      this.closeMenu(e);
    } else {
      this.openMenu(e);
    }

    this.updateAriaStateForTriggers();

    const linksLvl1 = this.querySelectorAll('a[data-menu-level="1"]');
    const menuMobileFooterLinks = this.querySelectorAll(
      "a.wt-page-nav-mega__aside-list__link",
    );

    toggleTabindex(linksLvl1);
    toggleTabindex(menuMobileFooterLinks);
    this.toggleMenuButtonAttr();

    // this.handleFocus();

    const isFullHeightDrawer = () =>
      document.querySelectorAll("body.nav-drawer-big").length;
    const drawerTopPadding = isFullHeightDrawer() ? 0 : this.getHeaderHeight();
    const drawerBodeEl = document.querySelector(".wt-drawer__content");
    const activeNavBodyClass = "menu-open";
    const activeOverlayBodyClass = "menu-drawer-overlay-on";
    const headerMenuParentLinkClass = "wt-header__nav-teaser__link--parent";

    if (e.currentTarget.classList.contains(headerMenuParentLinkClass)) {
      this.openMobileSubmenu(e.currentTarget.attributes?.href?.value);
    }

    document.body.classList.toggle(activeNavBodyClass);
    document.body.classList.toggle(activeOverlayBodyClass);
    drawerBodeEl.style.setProperty("padding-top", drawerTopPadding);
  }

  toggleMenuButtonAttr() {
    const dataOpen =
      this.menuToggleButton.dataset.open === "true" ? "false" : "true";
    this.menuToggleButton.dataset.open = dataOpen;
  }

  toggleThirdOptionMenu() {
    const menuButton = document.querySelector(
      ".wt-header__icon.wt-header__menu-trigger.wt-icon",
    );

    if (this.headerMenu) {
      const dataOpen = menuButton.dataset.open === "true" ? "false" : "true";
      menuButton.dataset.open = dataOpen;
    }
  }

  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input, select, [tabindex]";
    const focusableElements = () =>
      Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
        (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  init() {
    if (!document.querySelector(`.${this.pageOverlayClass}`)) {
      const overlay = document.createElement("div");
      overlay.classList.add(this.pageOverlayClass);

      document.body.appendChild(overlay);
    }

    this.handleTabindex();

    window.addEventListener("resize", this.handleTabindex.bind(this));

    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last, focusableElements } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.isOpen) {
          this.toggleMenu(e);
        }
      }

      if (!this.isDesktop() || this.isAlwaysMobile()) {
        if (isTabPressed) {
          if (e.shiftKey && document.activeElement === first) {
            last.focus();
            e.preventDefault();
          } else if (!e.shiftKey && document.activeElement === last) {
            first.focus();
            e.preventDefault();
          }
        }
      }
    });

    this.triggers().forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        this.toggleMenu(e);
        this.toggleThirdOptionMenu();
      });
    });
  }
}

customElements.define("drawer-nav", DrawerNavSection);

class MegaMenuSection extends HTMLElement {
  constructor() {
    super();

    this.menuParentItems = this.querySelectorAll(
      ".wt-page-nav-mega__item--parent",
    );
    this.menuParentLinks = this.querySelectorAll(
      ".wt-page-nav-mega__link--parent",
    );
    this.menuSubmenuParentLinks = this.querySelectorAll(
      ".wt-page-nav-mega__sublist__link--parent",
    );

    this.classParentActiveMobile = "submenu-opened";
    this.classParentActiveDesk = "dropdown-opened";
    this.classBodyActiveDesk = "dropdown-open-desk";

    this.isAlwaysMobile = () =>
      document.querySelector("page-header").dataset.alwaysMobileMenu === "true";
    this.desktopBreakpoint = 1200;
    this.isDesktop = () =>
      window.matchMedia(`(min-width: ${this.desktopBreakpoint}px)`).matches;

    this.currentlyActiveSubmenu = null;
  }

  connectedCallback() {
    this.init();
  }

  toggleParentMob(el) {
    const { menuParentLinks, classParentActiveMobile } = this;
    const subMenuWrapper = el.nextElementSibling;
    const subMenuLinksLevel2 = subMenuWrapper.querySelectorAll(
      "[data-menu-level='2']",
    );

    toggleTabindex(subMenuLinksLevel2);

    menuParentLinks.forEach((link) => {
      if (link !== el) {
        link.classList.remove(classParentActiveMobile);

        // Ensure all submenus are closed and tabindex is set to -1
        const otherSubMenuWrapper = link.nextElementSibling;
        const otherSubMenuLinksLevel2 = otherSubMenuWrapper.querySelectorAll(
          "[data-menu-level='2']",
        );
        const otherSubMenuLinksLevel3 = otherSubMenuWrapper.querySelectorAll(
          "[data-menu-level='3']",
        );

        link.classList.remove(classParentActiveMobile);
        setTabindex(otherSubMenuLinksLevel2, "-1");
        setTabindex(otherSubMenuLinksLevel3, "-1");
      } else {
        el.classList.toggle(classParentActiveMobile);

        if (!el.classList.contains(classParentActiveMobile)) {
          const openedSubmenu =
            el.nextElementSibling.querySelectorAll(".submenu-opened");

          openedSubmenu.forEach((submenuLink) => {
            submenuLink.classList.remove("submenu-opened");
            const nestedSubMenuLinks =
              submenuLink.nextElementSibling.querySelectorAll(
                'a[data-menu-level="3"]',
              );
            setTabindex(nestedSubMenuLinks, "-1");
          });
        }
      }
    });
  }

  toggleSubmenuMob(el) {
    const { menuSubmenuParentLinks, classParentActiveMobile } = this;
    const subMenuLinksLevel3 = el.nextElementSibling.querySelectorAll(
      "[data-menu-level='3']",
    );

    toggleTabindex(subMenuLinksLevel3);

    menuSubmenuParentLinks.forEach((link) => {
      if (link !== el) {
        link.classList.remove(classParentActiveMobile);

        // Ensure all third-level submenus are closed and tabindex is set to -1
        const otherSubMenuLinksLevel3 =
          link.nextElementSibling.querySelectorAll("[data-menu-level='3']");

        link.classList.remove(classParentActiveMobile);
        setTabindex(otherSubMenuLinksLevel3, "-1");
      } else {
        el.classList.toggle(classParentActiveMobile);
      }
    });
  }

  hasClassMobileNav() {
    return document.body.classList.contains("mobile-nav");
  }

  isMobileMenu() {
    return (
      !window.matchMedia("(min-width: 1200px)").matches ||
      this.hasClassMobileNav()
    );
  }

  initTabindex() {
    if (this.isDesktop() && !this.isAlwaysMobile()) {
      const parentLinks = this.querySelectorAll('a[data-menu-level="1"]');
      setTabindex(parentLinks, "0");
    }
  }

  init() {
    const {
      menuParentLinks,
      menuSubmenuParentLinks,
      menuParentItems,
      classBodyActiveDesk,
      classParentActiveDesk,
    } = this;

    menuParentLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        if (this.isMobileMenu()) {
          e.preventDefault();
          this.toggleParentMob(link);
        }
      });
    });

    menuSubmenuParentLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleSubmenuMob(link);
      });
    });

    this.initTabindex();

    const toggleSubmenuDesk = (item) => {
      const parentLink = item.querySelector('a[data-menu-level="1"]');
      const submenuLinks = parentLink.nextElementSibling.querySelectorAll(
        'a[data-menu-level="2"],a[data-menu-level="3"]',
      );
      if (this.isDesktop() && !this.isAlwaysMobile()) {
        setTabindex(
          submenuLinks,
          item.classList.contains(classParentActiveDesk) ? "0" : "-1",
        );
      }
    };

    const leftSubmenuClass = "submenu--left";
    menuParentItems.forEach((item, idx) => {
      addEventListeners(item, ["mouseover", "focusin"], (e) => {
        document.body.classList.add(classBodyActiveDesk);
        item.classList.add(classParentActiveDesk);
        const xCoords = item.getBoundingClientRect().x;
        const windowWidth = window.innerWidth;
        const isElementInSecondHalfOfWindow = xCoords > windowWidth / 2;

        item.classList.toggle(leftSubmenuClass, isElementInSecondHalfOfWindow);

        toggleSubmenuDesk(item);
      });

      addEventListeners(item, ["mouseout", "focusout"], (e) => {
        document.body.classList.remove(classBodyActiveDesk);
        item.classList.remove(classParentActiveDesk);

        const xCoords = item.getBoundingClientRect().x;
        const windowWidth = window.innerWidth;
        const isElementInSecondHalfOfWindow = xCoords > windowWidth / 2;

        item.classList.remove(leftSubmenuClass);

        toggleSubmenuDesk(item);
      });
    });
  }
}

customElements.define("mega-menu-section", MegaMenuSection);

class CollapsibleSection extends HTMLElement {
  constructor() {
    super();
    this.extractOptionsFromURL();

    this.previousWidth = window.innerWidth;

    // Property Initializations
    this.selectorInteractiveElements =
      "button, [href], input, select, [tabindex]";
    this.triggerClass = ".wt-collapse__trigger";
    this.classActiveTrigger = "wt-collapse__trigger--active";
    this.openAttr = this.dataset.open;
    this.accordionSet = this.dataset.accordionSet;
    this.mobileOnly = this.hasAttribute("data-mobile-only");
    this.breakpoint = 900;

    // Element References
    this.trigger = this.querySelector(this.triggerClass);
    this.content = this.querySelector(".wt-collapse__target");

    // Event delegation method binding
    this.handleDelegatedEvent = this.handleDelegatedEvent.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  static get observedAttributes() {
    return ["data-open"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-open" && oldValue !== newValue) {
      this.handleAriaAndTabindex();
    }
  }

  connectedCallback() {
    this.initialize();

    // Add event delegation listener to the document
    document.addEventListener("click", this.handleDelegatedEvent);

    // Add resize event listener if mobileOnly is true
    if (this.mobileOnly) {
      window.addEventListener("resize", this.handleResize);
    }
  }

  disconnectedCallback() {
    // Remove delegated event listener
    document.removeEventListener("click", this.handleDelegatedEvent);

    if (this.mobileOnly) {
      window.removeEventListener("resize", this.handleResize);
    }
  }

  isOpen() {
    return this.dataset.open === "true";
  }

  isMobileView() {
    return window.innerWidth < this.breakpoint;
  }

  getInteractiveElements(container) {
    return Array.from(
      container.querySelectorAll(this.selectorInteractiveElements),
    ).filter((el) => !el.hasAttribute("disabled"));
  }

  handleAriaAndTabindex() {
    if (this.isOpen()) {
      this.trigger.setAttribute("aria-expanded", "true");
      this.setTabindex(this.getInteractiveElements(this.content), "0");
    } else {
      this.trigger.setAttribute("aria-expanded", "false");
      this.setTabindex(this.getInteractiveElements(this.content), "-1");
    }

    // Additional logic for mobile-only sections in desktop view
    if (this.mobileOnly && !this.isMobileView()) {
      // In desktop view, ensure content is accessible and trigger is not focusable
      this.setTabindex(this.getInteractiveElements(this.content), "0");
      this.trigger.setAttribute("tabindex", "-1");
    } else {
      // In mobile view, make sure the trigger is focusable
      this.trigger.setAttribute("tabindex", "0");
    }
  }

  setTabindex(elements, value) {
    elements.forEach((el) => el.setAttribute("tabindex", value));
  }

  extractOptionsFromURL() {
    const currentURL = window.location.href;
    const pattern = /option\.([^&]+)/g;

    const matches = currentURL?.match(pattern);
    const result = {};

    matches?.forEach((item) => {
      const [key, value] = item.split("=");
      const decodedValue = decodeURIComponent(value).replace("+", " ");

      const option = key.split(".")[1];

      if (result.hasOwnProperty(option)) {
        result[option].push(decodedValue);
      } else {
        result[option] = [decodedValue];
      }
    });

    activeOptions = result;
  }

  toggleState() {
    const isOpen = this.isOpen();
    this.dataset.open = isOpen ? "false" : "true";
    this.trigger.classList.toggle(this.classActiveTrigger);
  }

  toggleAccordion() {
    const accordionPanels = document.querySelectorAll(
      `collapsible-section[data-accordion-set="${this.accordionSet}"]`,
    );

    if (this.isOpen()) {
      this.toggleState();
    } else {
      accordionPanels.forEach((panelEl) => {
        if (panelEl !== this) {
          panelEl.dataset.open = "false";
          const panelTrigger = panelEl.querySelector(this.triggerClass);
          if (panelTrigger) {
            panelTrigger.classList.remove(this.classActiveTrigger);
          }
        }
      });
      this.dataset.open = "true";
      this.trigger.classList.add(this.classActiveTrigger);
    }
  }

  handleDelegatedEvent(event) {
    const trigger = event.target.closest(this.triggerClass);
    if (!trigger || !this.contains(trigger)) {
      return;
      // Clicked outside the trigger
    }

    if (this.accordionSet) {
      this.toggleAccordion();
    } else {
      this.toggleState();
    }
  }

  handleResize() {
    const currentWidth = window.innerWidth;

    if (currentWidth !== this.previousWidth) {
      this.previousWidth = currentWidth;

      if (this.isMobileView()) {
        this.enableCollapsible();
      } else {
        this.disableCollapsible();
      }
    }
  }

  enableCollapsible() {
    // If the section is supposed to be open by default, respect that
    if (this.openAttr === "true") {
      this.dataset.open = "true";
      this.trigger.classList.add(this.classActiveTrigger);
    } else {
      this.dataset.open = "false";
      this.trigger.classList.remove(this.classActiveTrigger);
    }

    this.trigger.setAttribute("tabindex", "0");
    this.handleAriaAndTabindex();
  }

  disableCollapsible() {
    this.dataset.open = "true";
    this.trigger.classList.remove(this.classActiveTrigger);

    this.trigger.setAttribute("aria-expanded", "false");
    this.setTabindex(this.getInteractiveElements(this.content), "0");
    this.trigger.setAttribute("tabindex", "-1");
  }

  initialize() {
    if (this.mobileOnly) {
      if (this.isMobileView()) {
        this.enableCollapsible();
      } else {
        this.disableCollapsible();
      }
    } else {
      if (this.openAttr === "true") {
        this.trigger.classList.add(this.classActiveTrigger);
      }
      this.trigger.setAttribute("tabindex", "0");
      this.handleAriaAndTabindex();
    }
  }
}

customElements.define("collapsible-section", CollapsibleSection);

class JsLink extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleClickOrEnter = this.handleClickOrEnter.bind(this);
    this.handleMouseWheelClick = this.handleMouseWheelClick.bind(this);
    this.worksOnlyForMobile = Boolean(this.dataset.mobile);
    this.initialize();
  }

  initialize() {
    this.addEventListener("click", this.handleClickOrEnter);
    this.addEventListener("mousedown", this.handleMouseWheelClick);
  }

  removeEventListeners(){
    this.removeEventListener("click", this.handleClickOrEnter);
    this.removeEventListener("mousedown", this.handleMouseWheelClick);
  }

  handleClickOrEnter(e) {
    if (this.worksOnlyForMobile && window.innerWidth > 600) return;
    const href = this.getAttribute("href");
    const target = this.getAttribute("target");
    if (e.type === "click") {
      if (target === "_blank") {
        window.open(href, target);
      } else {
        window.location = href;
      }
    } else if (e.type === "mousedown") {
      e.preventDefault();
      if (e.button === 1) {
        // Detect middle mouse button
        window.open(href, "_blank");
      }  
    }
  }

  handleMouseWheelClick(e){
    if (this.worksOnlyForMobile && window.innerWidth > 600) return;
    const href = this.getAttribute("href");
    if (e.type === "mousedown") {
      e.preventDefault();
      if (e.button === 1) {
        // Detect middle mouse button
        window.open(href, "_blank");
      }  
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

customElements.define("js-link", JsLink);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    // Event handler bindings
    this._onModalCloseClick = this._onModalCloseClick.bind(this);
    this._onKeyUp = this._onKeyUp.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onPointerUp = this._onPointerUp.bind(this);
    this._onClick = this._onClick.bind(this);
    this.getFocusableElements = this.getFocusableElements.bind(this);
  }

  connectedCallback() {
    if (!this.moved) {
      this.moved = true;
      document.body.appendChild(this);
    }

    // Add event listeners
    const modalCloseButton = this.querySelector('[id^="ModalClose-"]');
    if (modalCloseButton) {
      modalCloseButton.addEventListener("click", this._onModalCloseClick);
    }

    this.addEventListener("keyup", this._onKeyUp);
    this.addEventListener("keydown", this._onKeyDown);

    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", this._onPointerUp);
    } else {
      this.addEventListener("click", this._onClick);
    }
  }

  disconnectedCallback() {
    // Remove event listeners
    const modalCloseButton = this.querySelector('[id^="ModalClose-"]');
    if (modalCloseButton) {
      modalCloseButton.removeEventListener("click", this._onModalCloseClick);
    }

    this.removeEventListener("keyup", this._onKeyUp);
    this.removeEventListener("keydown", this._onKeyDown);

    if (this.classList.contains("media-modal")) {
      this.removeEventListener("pointerup", this._onPointerUp);
    } else {
      this.removeEventListener("click", this._onClick);
    }
  }

  temporaryHideFocusVisible() {
    document.body.classList.add("no-focus-visible");
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();

    // Focus management
    const modalCloseButton = this.querySelector('[id^="ModalClose-"]');
    if (modalCloseButton) {
      modalCloseButton.setAttribute("tabindex", "0");
      modalCloseButton.focus();

      this.temporaryHideFocusVisible();
    }

    // Update tabindex of focusable elements inside modal
    const { focusableElements } = this.getFocusableElements();
    focusableElements.forEach((el) => el.setAttribute("tabindex", "0"));

    window.pauseAllMedia?.();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");

    // Focus management
    if (this.openedBy && typeof this.openedBy.focus === "function") {
      this.openedBy.focus();

      this.temporaryHideFocusVisible();
    }
    this.openedBy = null;

    // Reset tabindex of focusable elements inside modal
    const { focusableElements } = this.getFocusableElements();
    focusableElements.forEach((el) => el.setAttribute("tabindex", "-1"));

    window.pauseAllMedia?.();
  }

  getFocusableElements() {
    const focusableElementsSelector =
      'button, [href], [role="button"], a, input, select, textarea';
    const focusableElements = Array.from(
      this.querySelectorAll(focusableElementsSelector),
    ).filter(
      (el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden"),
      // && el.tabIndex >= 0,
    );

    return {
      focusableElements,
      first: focusableElements[0],
      last: focusableElements[focusableElements.length - 1],
    };
  }

  // Event handler methods
  _onModalCloseClick(event) {
    this.hide(false);
  }

  _onKeyUp(event) {
    if (event.code.toUpperCase() === "ESCAPE") {
      this.hide();
    }
  }

  _onKeyDown(event) {
    const isTabPressed =
      event.key === "Tab" || event.keyCode === 9 || event.code === "Tab";
    const { first, last } = this.getFocusableElements();

    if (
      event.key === "Escape" ||
      event.keyCode === 27 ||
      event.code === "Escape"
    ) {
      this.hide();
    }

    if (isTabPressed) {
      if (event.shiftKey) {
        if (
          document.activeElement === first ||
          document.activeElement === this
        ) {
          event.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  _onPointerUp(event) {
    if (
      event.pointerType === "mouse" &&
      !event.target.closest("deferred-media, product-model")
    ) {
      this.hide();
    }
  }

  _onClick(event) {
    if (event.target === this) {
      this.hide();
    }
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this)),
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true },
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

document.body.addEventListener("keydown", function (e) {
  const target = e.target;

  const isThumbnail = target.getAttribute("role") === "thumbnail";

  const isEnter = e.code === "Enter" || e.key === "Enter" || e.keyCode === 13;
  const isTab = e.code === "Tab" || e.key === "Tab" || e.keyCode === 9;
  const isSpace = e.code === "Space" || e.key === " " || e.keyCode === 32;
  const isSearch = target.dataset.search;

  if (isTab) {
    document.body.classList.remove("no-focus-visible");
  }

  const isButtonLike =
    target.getAttribute("role") === "button" ||
    target.getAttribute("role") === "option" ||
    target.tagName === "A" ||
    (target.tagName === "INPUT" &&
      ["radio", "checkbox"].includes(target.type)) ||
    target.tagName === "LABEL" ||
    target.tagName === "JS-LINK" ||
    isThumbnail;
  const keyboardSupport = isButtonLike && (isEnter || isSpace);

  if (keyboardSupport && !isThumbnail) {
    if (isEnter) {
      if (!isSearch) e.preventDefault();
      e.stopPropagation();
    }

    if (isSpace) {
      if (!isSearch) e.preventDefault();
    }
    target.click();
  } else if (keyboardSupport && isThumbnail) {
    let slideNumber;
    const mainSliderElement = document.querySelector("[data-gallery]");
    const mainSlides = mainSliderElement.querySelectorAll("li");

    const thumbSlideMediaId = e.target.dataset.slideMediaId;

    mainSlides.forEach((slide, id) => {
      if (slide.dataset.mediaId === thumbSlideMediaId) {
        slideNumber = id;
      }
    });

    if (mainSliderElement) {
      const swiperInstance = mainSliderElement.swiper;

      if (swiperInstance) {
        swiperInstance.slideTo(slideNumber);
        swiperInstance.slideReset();
        const currentSlide = mainSlides[slideNumber];
        const currentSlideBtn = currentSlide?.querySelector("button");
        const currentSlideVideo = currentSlide?.querySelector("video");
        const currentSlideImg = currentSlide?.querySelector("a");
        currentSlideBtn?.focus();
        currentSlideVideo?.focus();
        // if (currentSlideImg && !currentSlideBtn && !currentSlideVideo)
        currentSlideImg?.click();
      } else {
        console.error("Swiper instance not found on the element");
      }
    } else {
      console.error("Swiper element not found");
    }
  }
});

// for debug only TODO: remove this in final version
// document.addEventListener("focusin", function (event) {
//   console.log(`Current focused element: [${event.target.textContent}]`);
//   console.log(event.target);
// });

// document.addEventListener("shopify:section:load", (event) => {
//   console.log("Shopify section load:");
//   console.log(event);
// });
//
// document.addEventListener("shopify:section:select", (event) => {
//   console.log("Shopify section select:");
//   console.log(event);
// });
//
// document.addEventListener("shopify:section:reorder", (event) => {
//   console.log("Shopify section reorder:");
//   console.log(event);
// });
